import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { AuthService, ClientDataStoreService, MenuService, LearnService} from "@app/services";
import { Permission } from "../../interfaces/user";
import { ClientSummary } from "@app/interfaces";
import { Subscription } from "rxjs";
import { PermissionsService } from "@app/services/permissions.service";

@Component({
  selector: "app-mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrls: ["./mobile-menu.component.scss"]
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  joinCommunityLink = "";
  userToken: string;
  userInfo: ClientSummary;
  hasContentViewingPermission = false;
  hasJobSeekingPermission = false;
  hasJobBookingPermission = false;
  hasJobCheckingInPermission = false;
  hasJobSigningOffPermission = false;
  hasAccountsPermission = false;
  hasTalentPoolUsePermission = false;
  hasViewInsightsPermission = false;
  hasClientAdministratorPermission = false;
  showOpogoHub = false;
  defaultCandidatePhotoUrl: boolean = true;
  userName: string = "";
  showSettingsMenu: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(
    public router: Router,
    public menuService: MenuService,
    private auth: AuthService,
    private learnService: LearnService,
    private clientStore: ClientDataStoreService,
    private permissionsService: PermissionsService
  ) {
    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showOpogoHub = event.url.indexOf("/hub") !== -1;
      }
    });

    this.subscriptions.push(routerSubscription);
  }

  ngOnInit() {
    const clientSummarySubscription = this.clientStore.clientSummary$
      .subscribe(userInfo => this.updateUserInfo(userInfo));

    this.subscriptions.push(clientSummarySubscription);

    this.subscriptions.push(this.permissionsService.permissions$.subscribe(permissions => {
      this.updatePermissions(permissions);
    }));

    this.subscriptions.push(this.auth.tokenChanges$.subscribe(token => {
      this.userToken = token;
      this.joinCommunityLink = this.learnService.getLearnUrl(token || '');
    }));
  }

  private updateUserInfo(userInfo: ClientSummary) {
    this.userInfo = userInfo;
    this.defaultCandidatePhotoUrl =
      !userInfo.ProfileImageUrl || userInfo.ProfileImageUrl.includes('default-member-photo.png');
    this.userName = `${userInfo.FirstName} ${userInfo.LastName}`;
  }

  private updatePermissions(permissions: readonly Permission[]) {
    this.hasContentViewingPermission = permissions.indexOf(Permission.ContentViewing) !== -1;
    this.hasJobSeekingPermission = permissions.indexOf(Permission.JobSeeking) !== -1;
    this.hasJobBookingPermission = permissions.indexOf(Permission.JobBooking) !== -1;
    this.hasJobCheckingInPermission = permissions.indexOf(Permission.JobCheckingIn) !== -1;
    this.hasJobSigningOffPermission = permissions.indexOf(Permission.JobSigningOff) !== -1;
    this.hasAccountsPermission = permissions.indexOf(Permission.Invoice) !== -1;
    this.hasTalentPoolUsePermission = permissions.indexOf(Permission.Talent) !== -1;
    this.hasViewInsightsPermission = permissions.indexOf(Permission.ViewInsights) !== -1;
    this.hasClientAdministratorPermission =
      permissions.indexOf(Permission.ClientAdministrator) !== -1;
  }

  showHideRightMenu() {
    this.menuService.hideRight();
    this.showSettingsMenu = false;
  }

  showHideSettingsMenu() {
    this.showSettingsMenu = !this.showSettingsMenu;
  }

  logout() {
    const isOidcLogout = this.auth.logout();
    if (!isOidcLogout) {
      this.router.navigate(["login"]);
    }
    this.showHideRightMenu();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
